import axios from 'axios'
import qs from 'qs'
import * as auth from '@/services/auth'

const newAxios = axios.create({
  baseURL: '/api/'
})

newAxios.interceptors.request.use(
  function (config) {
    config.headers.token = auth.getToken()
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)

newAxios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      auth.logout()
    }
    return Promise.reject(error)
  }
)

export default newAxios



// WEBPACK FOOTER //
// ./src/services/axios.js